import React, {useEffect, useState} from 'react';
import {Route, Routes, useLocation} from "react-router";
import Header from "./components/Header";
import Preloader from "./components/Preloader";
import Home from "./components/Home";
import Hakkimizda from "./components/Hakkimizda";
import DijitalNetwork from "./components/DijitalNetwork";
import Iletisim from "./components/Iletisim";
import Giris from "./components/Giris";
import Footer from "./components/Footer";
import Hedefleme from "./components/Hedefleme";
import {ToastContainer} from "react-toastify";
import {AuthProvider} from "./context/AuthProvider";
import Demo from "./components/Demo";
import './App.css';
import {Helmet} from "react-helmet";
import Lenovo from "./components/Lenovo";
import Nesine from "./components/Nesine";
import HepsiBurada from "./components/HepsiBurada";
import Castrol from "./components/Castrol";
import Dyson from "./components/Dyson";
import Shark from "./components/Shark";
import Podcasts from "./components/Podcasts";
import Digital343 from "./components/podcast/Digital343";
import Petlas from "./components/Petlas";
import Lassa from "./components/Lassa";
import KocakGold from "./components/KocakGold";
import Aygaz from "./components/Aygaz";
import CocaCola from "./components/CocaCola";
import Axess from "./components/Axess";
import Kupa from "./components/Kupa";
import Arko from "./components/Arko";
import Toyota from "./components/Toyota";

function App() {
    const location = useLocation();


    return (
        <AuthProvider>

            <Preloader/>

                {location.pathname!=="/giris" && <Header/>}
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/hakkimizda" element={<Hakkimizda/>}/>
                    <Route path="/dijital-network" element={<DijitalNetwork/>}/>
                    <Route path="/iletisime-gecin" element={<Iletisim/>}/>
                    <Route path="/giris" element={<Giris/>}/>
                    <Route path="/hedefleme-seceneklerimiz" element={<Hedefleme/>}/>
                    <Route path="/demo" element={<Demo/>}/>
                    <Route path="/lenovo" element={<Lenovo/>}/>
                    <Route path="/nesine" element={<Nesine/>}/>
                    <Route path="/hepsiburada" element={<HepsiBurada/>}/>
                    <Route path="/castrol-edge" element={<Castrol/>}/>
                    <Route path="/dyson" element={<Dyson/>}/>
                    <Route path="/shark" element={<Shark/>}/>
                    <Route path="/petlas" element={<Petlas/>}/>
                    <Route path="/lassa" element={<Lassa/>}/>
                    <Route path="/podcastler" element={<Podcasts/>}/>
                    <Route path="/podcast/343-digital" element={<Digital343/>}/>
                    <Route path="/kocak-gold" element={<KocakGold/>}/>
                    <Route path="/aygaz" element={<Aygaz/>}/>
                    <Route path="/cocacola" element={<CocaCola/>}/>
                    <Route path="/axess" element={<Axess/>}/>
                    <Route path="/kupa" element={<Kupa/>}/>
                    <Route path="/arko" element={<Arko/>}/>
                    <Route path="/toyota" element={<Toyota/>}/>
                </Routes>
            <Footer/>
            <ToastContainer />

        </AuthProvider>
    );
}

export default App;